import { BatchOperationType } from '@repo/contracts/common';

const TYPE_KEYS: Record<BatchOperationType, string> = {
  [BatchOperationType.FLIGHT_LIST_IMPORT_PIPELINE]: 'flightList',
  [BatchOperationType.FLIGHT_LIST_IMPORT_APM_PIPELINE]: 'flightListApm',
  [BatchOperationType.ROUTE_LIST_IMPORT_PIPELINE]: 'routeList',
  [BatchOperationType.FLIGHT_STATUS_REFRESH]: 'statusRefresh',
  [BatchOperationType.PROCESS_IMPORT]: 'processImport',
  [BatchOperationType.CHANGESET_COMMIT]: 'changesetCommit',
  [BatchOperationType.REBUILD_DERIVED_DATA]: 'rebuildDerivedData',
  [BatchOperationType.DETECT_APPLICABLE_CHANGES]: 'detectChanges',
  [BatchOperationType.CALCULATE_STATUSES]: 'calculateStatuses',
};

export function getBatchOperationTypeLabel(
  type: BatchOperationType,
  t: (key: string) => string,
): string {
  const key = TYPE_KEYS[type];
  return key ? t(`batchOperations.typeLabels.${key}`) : type;
}
